module.exports = __webpack_public_path__ + "static/media/icon-toggle-on.937dd7fb.svg";